
import {Inject, Injectable} from '@angular/core';

import {BehaviorSubject, firstValueFrom, Observable} from 'rxjs';
import {Client as ConversationsClient, ConnectionState} from "@twilio/conversations";
import {ChatHttpService} from "./chat-http.service";
import {ITimeoutService} from "angular";

@Injectable({providedIn: 'root'})
export class ChatService {

  private _conversationsClient: BehaviorSubject<ConversationsClient> = new BehaviorSubject(undefined);
  public readonly conversationsClient: Observable<ConversationsClient> = this._conversationsClient.asObservable();

  private colorPalletSmall = [
    '#7F5347',
    '#BB3354',
    '#E2445C',
    '#FF7575',
    '#FDAB3D',
    '#CAB641',
    '#9CD326',
    '#037F4C',
    '#00C875',
    '#4ECCC6',
    '#225091',
    '#579BFC',
    '#5559DF',
    '#7E3B8A',
    '#401694',
    '#FAA1F1',
    '#FF5AC4',
    '#A25DDC',
    '#718815',
    '#9AADBD'
  ];

  constructor(@Inject(ChatHttpService) private chatHttpService: ChatHttpService) {
  }

  initChat = async () => {
    this.chatHttpService.getChatInfo()
      .subscribe((chatInfo) => {
        this._conversationsClient.next(new ConversationsClient(chatInfo.token));
      })
    // const chatInfo = await firstValueFrom(this.chatHttpService.getChatInfo());
    // // this.conversationsClient = new ConversationsClient(chatInfo.token);
    // this._conversationsClient.next(new ConversationsClient(chatInfo.token));
  };

  getConversationClient() {
    return this._conversationsClient.getValue();
  }

  destroyChat() {
    const conversationClientRef = this._conversationsClient.getValue();
    if (conversationClientRef) {

      if (conversationClientRef.connectionState === 'connected') {
        conversationClientRef.shutdown()
          .then(() => {
            this._conversationsClient.next(undefined);
          })
      } else {
        this._conversationsClient.next(undefined);
      }

    }
  }

  getCurrentUser() {
    if (this._conversationsClient) {
      const client = this._conversationsClient.getValue();
      return client.user;
    }
  }

  getColorById(id) {
    const hash = this.hashStr(id);
    const index = hash % (this.colorPalletSmall?.length || this.colorPalletSmall.length);
    return this.colorPalletSmall[index]
  }

  private hashStr(str) {
    let hash = 0;
    if (str) {
      for (let i = 0; i < str.length; i++) {
        let charCode = str.charCodeAt(i);
        hash += charCode;
      }
    }
    return hash;
  }

}
